import {
  COMMUNITY_EXPLORE_LINK,
  COMMUNITY_LINK,
  COMMUNITY_PILLARS,
  COMMUNITY_REGISTER_LINK,
  COMMUNITY_STEPS,
} from "./data/DiscordPageData";

export default function DiscordAboutCommunity() {
  return (
    <>
      {/* ── ABOUT THE QUANTUM COMMUNITY ──────────────────────────── */}
      <section className="dsc-section" id="community">
        <div className="dsc-eyebrow">About the Quantum Community</div>
        <h2 className="dsc-h2">
          More than a server. <span className="hi">A working company.</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          The Discord is where the conversation happens. The{" "}
          <strong>Quantum Community portal</strong> is where the work is
          organised, measured and rewarded. Every message you send, commit you
          push and stream you host is tracked, scored and turned into a rank
          you can show off.
        </p>

        <div className="dsc-pillars">
          {COMMUNITY_PILLARS.map((p) => (
            <div key={p.title} className="dsc-pillar">
              <div className="dsc-pillar-icon" aria-hidden>
                {p.icon}
              </div>
              <h3 className="dsc-pillar-title">{p.title}</h3>
              <p className="dsc-pillar-text">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="dsc-steps-head">How to get started</div>
        <ol className="dsc-steps">
          {COMMUNITY_STEPS.map((s) => (
            <li key={s.n} className="dsc-step">
              <span className="dsc-step-n">{s.n}</span>
              <div className="dsc-step-title">{s.title}</div>
              <p className="dsc-step-text">{s.text}</p>
            </li>
          ))}
        </ol>

        <div className="dsc-portal-row">
          <a
            href={COMMUNITY_REGISTER_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-btn-join"
          >
            Create your portal account
          </a>
          <a
            href={COMMUNITY_EXPLORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-btn-ghost"
          >
            Explore the community ↗
          </a>
          <a
            href={COMMUNITY_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-portal-url"
          >
            community.quantumlogicslimited.com
          </a>
        </div>
      </section>
    </>
  );
}
